module.exports = __webpack_public_path__ + "img/img_function.efedc09c.png";